/*
  qs

  Returns a query selector
*/

const qs = string => document.querySelector(string);

/*
  qs

  Returns a query selector node list
*/

const qsa = string => document.querySelectorAll(string);

/*
  first

  Returns first node in list
*/

const first = hook => {
    return hook[0];
};

/*
  last

  Returns last node in list
*/

const last = hook => {
    return hook[hook.length - 1];
};

/*
  all

  Runs passed function to every
  node in list
*/

const all = (hook, cb) => {
    [].forEach.call(hook, el => cb(el));
};

export { qs, qsa, first, last, all };



// WEBPACK FOOTER //
// ./assets/js/helpers/querySelector.js